import axios from "axios";
import AppConstant from "../assets/js/AppConstant";

export const SubmitClaimDocument = async ({ ticketId, bodyPayload, isTicketV2 }) => {

  let url = `/marketing-claim-api/v1/ticket/${ticketId}/claim`;
  if(isTicketV2){
    url = `/marketing-claim-api/v2/ticket/${ticketId}/claim`;
  }
  const response = await axios.patch(
    AppConstant.MAIN_URL + url,
    bodyPayload
  );

  return response;
};

export const SubmitClaimReview = async ({
  ticketId,
  bodyPayload,
  isSkipValidateApprover,
  isTicketV2
}) => {

  let url = `/marketing-claim-api/v1/ticket/${ticketId}/claim-review`;
  if(isTicketV2){
    url = `/marketing-claim-api/v2/ticket/${ticketId}/claim-review`;
  }

  const response = await axios.post(
    AppConstant.MAIN_URL + url,
    { ...bodyPayload, is_skip_validate_approvers: isSkipValidateApprover }
  );

  return response;
};

export const UpdateClaimTicket = async ({ ticketId, bodyPayload }) => {
  return await axios({
    method: "patch",
    url: `/marketing-claim-api/v1/ticket/${ticketId}/claim-revise`,
    data: bodyPayload,
  });
};
